import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesSupportMain } from './modules/ui/Main';

const SupportPage = (
  <SuspensePage>
    <PagesSupportMain />
  </SuspensePage>
);

export default SupportPage;
